// Firebase users.type mirrors the relational database type_id; type 1 ("user") is shown as "Donatore".
export const USER_TYPE = {
	USER: 1,
	PARTNER: 2,
	CARITAS_SUPERVISOR: 3,
	BENEFICIARY: 4,
	DIOCESE_ADMIN: 5,
	FUND_SUPERVISOR: 6,
	FUND_ADMIN: 7,
	ADMIN: 10
};

export function isAdminUser(user) {
	return Boolean(user) && Number(user.type) === USER_TYPE.ADMIN;
}

const USER_TYPES = [
	{id: USER_TYPE.USER, label: "Donatore", editable: true},
	{id: USER_TYPE.PARTNER, label: "Partner", editable: true},
	{
		id: USER_TYPE.CARITAS_SUPERVISOR,
		label: "Supervisore",
		usersPageLabel: "Supervisore Caritas",
		editable: true
	},
	{id: USER_TYPE.BENEFICIARY, label: "Beneficiario", editable: true},
	{id: USER_TYPE.DIOCESE_ADMIN, label: "Amministr. Diocesi", editable: true},
	{id: USER_TYPE.FUND_SUPERVISOR, label: "Supervisore Fondi", editable: false},
	{id: USER_TYPE.FUND_ADMIN, label: "Amministr. Fondi", editable: false},
	{id: USER_TYPE.ADMIN, label: "Admin", editable: true}
];

export const USER_TYPE_OPTIONS = USER_TYPES
	.filter(userType => userType.editable)
	.map(({id, label}) => ({value: id, name: label}));

export function getUserTypeName(type, context = "default") {
	const userType = USER_TYPES.find(userType => userType.id === type);
	return userType
		? userType[`${context}Label`] || userType.label
		: USER_TYPES[0].label;
}
